import { useContext, useState } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import LabelWithCount from './LabelWithCount';
import standardFeatures from './standardFeatures';
import { CommonWrapper } from './styles';
import type WithClassName from './WithClassName';

function Features({ className }: WithClassName) {
  const [show, setShow] = useState(false);
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { facetData } = useContext(FacetDataContext);
  const facetFeatures =
    facetData.features?.buckets?.filter(f =>
      standardFeatures.includes(f.key)
    ) ?? [];

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-features"
      facetContent={standardFeatures}
      facetName="features"
      show={show}
      onToggle={() => {
        setShow(!show);
      }}
    >
      <CommonWrapper>
        {facetFeatures.map(({ key, count, displayName }) => (
          <Checkbox
            checked={appliedFilters.features?.includes(key)}
            facet="features"
            filter={key}
            id={`features-${displayName}`}
            key={key}
            label={<LabelWithCount count={count} displayName={displayName} />}
            onChange={() =>
              updateListFilter({
                filterKey: 'features',
                value: key
              })
            }
          />
        ))}
      </CommonWrapper>
    </FilterDrawer>
  );
}

export default Features;
